import React, { useState, useEffect } from "react"
import { Pagination } from "semantic-ui-react"
import moment from "moment"
import { SegmentForm } from "@thairath/dmp-segment"
import admin from "../../libs/admin"
import { checkPermission } from "../../helper/functions"
import axios from "axios"

var ReactBsTable = require("react-bootstrap-table")
var BootstrapTable = ReactBsTable.BootstrapTable
var TableHeaderColumn = ReactBsTable.TableHeaderColumn

const itemsPerPage = 10
const statusMap = {
	1: "waiting",
	2: "success",
	3: "failed",
}

const Dashboard = (props) => {
	const user = admin.getCookieData()
	const hasViewPermission = checkPermission(user.permission, "look_a_like_view")
	const hasEditPermission = checkPermission(user.permission, "look_a_like_edit")

	const [lookALikes, setLookALikes] = useState([])
	const [filterText, setFilterText] = useState("")
	const [searchQuery, setSearchQuery] = useState("")
	const [activePage, setActivePage] = useState(1)
	const [totalPages, setTotalPages] = useState(1)

	const username = user.firstname && user.lastname ? `${user.firstname} ${user.lastname}` : user.username || "Unknown"

	const handlePageChange = (e, { activePage }) => {
		setActivePage(activePage)
	}

	const handleSearchChange = (e) => {
		setFilterText(e.target.value)
	}

	const handleSearch = () => {
		setSearchQuery(filterText)
		setActivePage(1)
	}

	const handleKeyPress = (e) => {
		if (e.key === "Enter") {
			handleSearch()
		}
	}

	const IdFormatter = (cell) => {
		return cell ? cell : "-"
	}

	const dateFormatter = (cell) => {
		if (!cell) return "-"
		return moment(cell).format("DD/MM/YYYY HH:mm")
	}

	const statusFormatter = (cell) => {
		if (!cell) return "-"
		return statusMap[cell] || statusMap[3]
	}

	const onSubmitError = (error) => {
		const { response } = error
		const { status, data } = response || {}

		if (status === 409 && data?.message === "DUPLICATE_LOOK_A_LIKE_NAME") {
			alert("ชื่อ Look a Like นี้มีอยู่แล้ว กรุณาใช้ชื่ออื่น")
		} else {
			alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
		}
	}

	const actionButtonFormatter = (cell, row) => {
		const data = {
			...row,
			title: row.name,
			isActiveLookALike: true,
			disableEdit: true,
			lookALike: {
				tier: row.lookALikeTier,
				count: row.totalLookALikeAudience,
			},
		}
		if (row.status === 2) {
			data.LookALikeStatus = 2
			delete data.status
		}
		return (
			<div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
				<SegmentForm
					value={data}
					createBy={username}
					apiUrl={`${process.env.REACT_APP_API_ROOT}/segment/look-a-like`}
					enableLookalike={true}
					renderButton={(props) => (
						<button {...props} className="btn btn-primary btn-sm" disabled={!hasEditPermission}>
							<i className="fas fa-edit"></i> ดูรายละเอียด
						</button>
					)}
					onSuccess={() => {}}
					onError={onSubmitError}
				/>
			</div>
		)
	}

	const getLookALikes = async () => {
		try {
			const params = { page: activePage, limit: itemsPerPage }
			if (searchQuery) params.search = searchQuery
			const response = await axios.get(`${process.env.REACT_APP_API_ROOT}/segment/look-a-like`, { params })
			const data = response.data
			setLookALikes(data.lookALikes || [])
			setTotalPages(data.totalPages || 1)
		} catch (error) {
			console.error("Error fetching Look a Like data:", error)
		}
	}

	useEffect(() => {
		if (!hasViewPermission) {
			props.history.push("/")
		} else {
			getLookALikes()
		}
	}, [hasViewPermission, activePage, searchQuery])

	return (
		<div className="card shadow mb-4">
			<div className="card-header py-3">
				<h6 className="m-0 font-weight-bold text-primary">Look a Like Dashboard</h6>
			</div>
			<div className="card-body">
				{/* Filter Section */}
				<div className="row mb-3">
					<div className="col-12 mb-2">
						<SegmentForm
							value={{
								isActiveLookALike: true,
							}}
							apiUrl={`${process.env.REACT_APP_API_ROOT}/segment/look-a-like`}
							createBy={username}
							enableLookalike={true}
							renderButton={(props) => (
								<button {...props} className="btn btn-success btn-sm px-3" disabled={!hasEditPermission}>
									สร้าง +
								</button>
							)}
							onSuccess={() => getLookALikes()}
							onError={onSubmitError}
						/>
					</div>
					<div className="col-6">
						<div className="input-group md-form form-sm form-2 pl-0">
							<input
								className="form-control my-0 py-1 lime-border"
								type="text"
								placeholder="ค้นหาชื่อ Look a Like..."
								aria-label="Search"
								value={filterText}
								onChange={handleSearchChange}
								onKeyPress={handleKeyPress}
							/>
							<div className="input-group-append">
								<span className="input-group-text lime lighten-2" id="basic-text1" style={{ cursor: "pointer" }} onClick={handleSearch}>
									<i className="fas fa-search text-grey" aria-hidden="true"></i>
								</span>
							</div>
						</div>
					</div>
				</div>

				{/* Table */}
				<div className="table-responsive" style={{ overflowX: "auto" }}>
					<BootstrapTable
						data={lookALikes || []}
						className="table table-striped"
						keyField="_id"
						options={{ noDataText: "ไม่พบข้อมูล" }}
						tableStyle={{ minWidth: "900px" }}
					>
						<TableHeaderColumn dataField="lookALikeId" width="10%" dataFormat={IdFormatter}>
							Look a Like ID
						</TableHeaderColumn>
						<TableHeaderColumn dataField="name" width="30%">
							ชื่อ
						</TableHeaderColumn>
						<TableHeaderColumn dataField="lookALikeTier" width="10%">
							tier
						</TableHeaderColumn>
						<TableHeaderColumn dataField="totalLookALikeAudience" width="10%">
							จำนวน Audience
						</TableHeaderColumn>
						<TableHeaderColumn dataField="status" width="5%" align="center" dataFormat={statusFormatter}>
							สถานะ
						</TableHeaderColumn>
						<TableHeaderColumn dataField="createBy" width="15%">
							สร้างโดย
						</TableHeaderColumn>
						<TableHeaderColumn dataField="createdAt" width="10%" dataFormat={dateFormatter}>
							วันที่สร้าง
						</TableHeaderColumn>
						<TableHeaderColumn dataField="updatedAt" width="10%" dataFormat={dateFormatter}>
							แก้ไขล่าสุด
						</TableHeaderColumn>
						<TableHeaderColumn dataField="_id" width="10%" dataFormat={actionButtonFormatter} dataAlign="center">
							จัดการ
						</TableHeaderColumn>
					</BootstrapTable>
				</div>

				{/* Pagination */}
				<div className="row mt-3">
					<div className="col-12">
						{lookALikes && lookALikes.length > 0 && (
							<Pagination activePage={activePage} onPageChange={handlePageChange} totalPages={totalPages} ellipsisItem={null} />
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default Dashboard
